// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1yhtf","active":"NavigationItem_active__2ySZv"};